<template>
    <v-card>
    <v-container fluid>
    <v-card>
    <form ref="form"
    v-model="valid"
    lazy-validation>
        <v-spacer></v-spacer>
        <v-row align="end"
        style="height: 150px">
            <v-col  cols="12" sm="6" md="3">
            <v-container>
                <template>
                <v-file-input v-model="editedItem.files"
                    accept=".xlsx"
                    label="Archivo excel"
                    placeholder="Seleccione su archivo"
                    name="file"  
                    id="file"
                ></v-file-input>
                </template>
            </v-container>
            </v-col>
              <v-col align-self="center" cols="12" sm="6" md="4">
                <v-btn :disabled="editedItem.files.length == 0" color="primary" @click="carga">Cargar</v-btn>
                <v-btn v-if="isTester" :disabled="editedItem.files.length == 0" color="success" @click="carga2">Carga Con Almacen</v-btn>
              </v-col>
        </v-row>
    </form>  
      <v-spacer></v-spacer>
      </v-card>
      </v-container>
      <v-container fluid>
        <v-card>
         <v-card-title>
           <v-icon x-large>mdi-clipboard-list-outline</v-icon>Listado de Cambios
           <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Filtro"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
        :headers="headers"
        :items="mvm"
        :search="search"
        sort-by="calories"
        class="elevation-1"
      >
     
      </v-data-table>
      </v-card>
      </v-container>
      <v-spacer></v-spacer>
    <template>
    <div class="text-center">
        <v-btn type="button" :disabled="btnap" color="primary" @click="onexport1">Aplicar Cambios</v-btn>
        <v-btn v-if="isTester" type="button" :disabled="btnap" color="success" @click="onexport2">Aplicar Cambios con Almacen</v-btn>
        <v-btn type="button" color="primary" @click="onexport">Descargar Resultados</v-btn>
    </div>
    
    </template>
      <v-dialog v-model="dialog_new" max-width="900px">
      <v-stepper v-model="e1" vertical>
             <p align="right"><v-btn color="blue darken-1" text @click="close">X</v-btn></p>
            <v-stepper-step :complete="e1 > 1" step="1" :rules="[value => !! step_error1]" :color="step_color1">{{ this.step_txt1 }}
                <small>{{this.step_txt2}}</small>
            </v-stepper-step>
            <v-stepper-content step="1">
            <v-card height="100px">
                <div class="text-center">
                <v-progress-circular v-if="progressBar" indeterminate size="64" color="primary"></v-progress-circular><br>
                {{this.msj_proceso}}
                </div>
            </v-card>
            </v-stepper-content>  
        </v-stepper>
      </v-dialog>
      </v-card>
    </template>
    
    <script>
    import axios from 'axios'
    //import Vue from "vue";
    //import JsonExcel from "vue-json-excel";
    import XLSX from 'xlsx';
     
    //Vue.component("downloadExcel", JsonExcel);
    
    export default {
      data: () => ({
        
        search: '',
        search2: '',
        api_tool_url: process.env.VUE_APP_API_TOOL_URL,
        dialog: false,
        dialog_pass: false,
        dialog_new: false,
        dialog_detail: false,
        valid: true,
        menu: false,
        menu2: false,
        e1: 0,
        btnap:true,
        btn: false,
        msj_proceso:'',
        progressBar1: false,
        progressBar: false,
        overlay: false,
        step_error1: true,
        step_error2: true,
        step_error3: true,
        step_color1:"primary",
        step_color2:"primary",
        step_color3:"primary",
        RequestProposal_id:'',
        step_txt1:'',
        step_txt2:'',
        TurningStorageArea_id:'',
        TurningStorageArea_Desc:'',
        OpPoint_id: '',
        Supplier_Description:'',
        VendorPurchaseOrder_Num:'',
        Section_id:'',
        LastOpRepUser_id: '',
        RepEvent_Dttm: '',
        ApiUser_GivenName:'',
        status:'',
        CDay_id:'',
        CHour_Description:'',
        DateMvm:'',
        id_process:'',
        isTester: false,
        headers: [
          { text: 'PropuestaID', value: 'RequestProposal_id' },
          { text: 'OC', value: 'VendorPurchaseOrder_Num' },
          { text: 'Punto', value: 'OpPoint_id' },
          { text: 'AlmacenID', value: 'TurningStorageArea_id' },
          { text: 'Prov', value: 'Supplier_id' },  
          { text: 'R Social', value: 'Supplier_Description' },
          { text: 'Fecha del Cierre', value: 'Closing_Dt' }, 
          { text: 'Fecha del Turno Actual', value: 'CDay_id' },
          { text: 'Hora del Turno Actual', value: 'CHour_id' }, 
          { text: 'Fecha de cambio', value: 'NewCDay_id'},
          { text: 'Hora de cambio', value: 'NewCHour_id'}, 
          { text: 'Tipo de Cambio', value: 'Type_ind'},
          { text: 'Error Ind', value: 'RequestProposalStatus_Cd' },
          { text: 'Error Des', value: 'RequestProposalStatus_Desc' },
          
        ],
        mvm: [],
        tdetalle: [],
        seleccion:[],
        RequestMVM: ['Propuesta ID', 'Número de Orden', 'Punto', 'Almacen ID', 'Almacén', 'Proveedor', 'R Social', 'Sección id', 'Fecha del Turno', 'Hora del Turno', 'status', 'Usuario id', 'Nombre de Usuario', 'Fecha de Cambio'],
        tdetalle_vew: [],
        editedIndex: -1,
        editedItem: {
          seleccion:['Propuesta ID', 'Número de Orden', 'Punto', 'Almacen ID', 'Almacén', 'Proveedor', 'R Social','Sección id', 'Fecha del Turno', 'Hora del Turno', 'status', 'Usuario id', 'Nombre de Usuario', 'Fecha de Cambio'],
          ingresadato: [],
          fecha: new Date().toISOString().substr(0, 10),
          files: []
        },
        
        fechaRule: [
            v => !!v || 'Fecha es requerida'
        ],
        datoRule: [
            v => !!v || 'El dato es Requerido'
           
        ],
        
        config: {
          headers: {
            //'Authorization': 'Bearer ' + sessionStorage.getItem('access_token'),
            "api-user": sessionStorage.getItem('ApiUser_id')
          }
        }
      }),
    
      computed: {
        formTitle () {
          return this.editedIndex === -1 ? 'Nuevo Planning' : 'Editar Planning'
        }
      },
    
      watch: {
        dialog (val) {
          val || this.close()
        }
      },
    
      created () {
        this.initialize()
      },
    
      methods: {
        initialize () {
          
          /* axios.post(this.api_tool_url + '/get_planning', this.editedItem, this.config)
            .then(response => {
                this.mvm = response.data.ResultRows
                 if(response.data.ResultRows.length >= 1)
                 {
                     axios.post(this.api_tool_url + '/get_planning_detail', this.editedItem, this.config)
                        .then(response => {
                            this.tdetalle = response.data.ResultRows
                        })
                        .catch(error => {
                            this.tdetalle = []
                            alert(error.response.data.message)
                        })
                 }
            })
            .catch(error => {
              this.mvm = []
              alert(error.response.data.message)
            }), */
          /*
          let user = sessionStorage.getItem('ApiUser_id');
          if(user == 'miguel_tadakuma' 
          || user == 'diego_rivero' 
          || user == 'micaela_rios' 
          || user == 'miguel_bugueno' 
          || user == 'gabriel_cabrera' 
          || user == 'miriam_rodriguez' 
          || user == 'german_wilkinson' 
          || user == 'alexis_salazar' ){
          this.isTester = true;
          }else{
          this.isTester = false;
          }
          */

          axios.post(this.api_tool_url + '/get_roleuser', {ApiUser_id: sessionStorage.getItem('ApiUser_id')}, this.config)
            .then(response => {
                let roles = response.data.ResultRows
                if(roles.find(role => role.ApiRole_id == 'administrator' || role.ApiRole_id == 'internos')){
                  this.isTester = true;
                }else if (roles.find(role => role.ApiRole_id == 'externos')){
                  this.isTester = false;
                }
            })
            .catch(error => {
              alert(error.response.data.message)
            })
            
        },
    
        carga() {
                  this.btn = true
                  this.step_txt1="Buscando OCs"
                  this.step_txt2="Consultando"
                  this.dialog_new = true
                  this.e1 = 1
                  this.progressBar = true
                  this.step_error1 = true
                  this.step_error2 = true
                  this.step_error3 = true
                  this.btnap=true
                  this.step_color1 = "primary",
                  this.step_color2 = "primary",
                  this.step_color3 = "primary",
                  this.msj_proceso = "Por favor aguarde un momento mientras se procesa la solicitud. ¡No cerrar esta ventana!"
                  let data = new FormData();
                  this.mvm = []
                  data.append('foo', 'bar');
                  data.append('file', document.getElementById('file').files[0]);
                  data.append('email', sessionStorage.getItem('ApiUser_EMail'));
                  data.append('user', sessionStorage.getItem('ApiUser_id'));
      
     
                axios.post(this.api_tool_url + '/fileUpload', data, this.config)
                .then(response => {
                        //if(response.data.ResultRows.length >= 1) {
                        if(response.data && response.data.ResultRows && response.data.ResultRows.length >= 1) {

                            this.mvm = response.data.ResultRows
                            this.id_process = response.data.Proceso_id                         
                            if(response.data.status == "NoOK")
                            {
                              this.btnap=true
                            }
                            else{
                              this.btnap=false
                            }
                            this.e1 = 1
                            this.step_color1 = "#008000"
                            this.progressBar = false
                            this.msj_proceso = 'Se realizo la busqueda por el archivo correctamente.'
                            this.btn = false
                            this.active = false  
                        }
                        else {
                            this.e1 = 1
                            this.step_color1 = "#C0392B"
                            this.progressBar = false
                            this.msj_proceso = error
                            this.btn = false
                            this.active = true
                        }
                        this.btn = false
                    })
                    .catch(error => {
                        this.btn = false
                        this.step_error1 = false
                        this.progressBar = false
                        if (error.response && error.response.data && error.response.data.message) {
                            this.msj_proceso = error.response.data.message;
                        } else {
                            this.msj_proceso = 'Ocurrió un error al procesar el archivo.';
                        }
                        this.active = true
                    })
                    
                    
              },
        
        carga2() {
            this.btn = true
            this.step_txt1="Buscando OCs"
            this.step_txt2="Consultando"
            this.dialog_new = true
            this.e1 = 1
            this.progressBar = true
            this.step_error1 = true
            this.step_error2 = true
            this.step_error3 = true
            this.btnap=true
            this.step_color1 = "primary",
            this.step_color2 = "primary",
            this.step_color3 = "primary",
            this.msj_proceso = "Por favor aguarde un momento mientras se procesa la solicitud. ¡No cerrar esta ventana!"
            let data = new FormData();
            this.mvm = []
            data.append('foo', 'bar');
            data.append('file', document.getElementById('file').files[0]);
            data.append('email', sessionStorage.getItem('ApiUser_EMail'));
            data.append('user', sessionStorage.getItem('ApiUser_id'));


          axios.post(this.api_tool_url + '/fileUpload_TurningStorage', data, this.config)
          .then(response => {
                  //if(response.data.ResultRows.length >= 1) {
                  if(response.data && response.data.ResultRows && response.data.ResultRows.length >= 1) {

                      this.mvm = response.data.ResultRows
                      this.id_process = response.data.Proceso_id                          
                      if(response.data.status == "NoOK")
                      {
                        this.btnap=true
                      }
                      else{
                        this.btnap=false
                      }
                      this.e1 = 1
                      this.step_color1 = "#008000"
                      this.progressBar = false
                      this.msj_proceso = 'Se realizo la busqueda por el archivo correctamente.'
                      this.btn = false
                      this.active = false  
                  }
                  else {
                      this.e1 = 1
                      this.step_color1 = "#C0392B"
                      this.progressBar = false
                      this.msj_proceso = error.response.data.message
                      this.btn = false
                      this.active = true
                  }
                  this.btn = false
              })
              .catch(error => {
                  this.btn = false
                  this.step_error1 = false
                  this.progressBar = false
                  this.msj_proceso = error.response.data.message
                  this.active = true
              })
              
              
        },
        close() {
            this.dialog_new = false
        },    
        
    
        close () {
          this.dialog_new = false
        },
        close2 () {
          this.dialog_detail= false
        },
    
        onexport () { // On Click Excel download button
        
          // export json to Worksheet of Excel
          // only array possible
          const header_r_f = ['Propuesta ID', 'OC', 'Punto', 'Almacen ID',  'Prov', 'R Social', 'Fecha del Turno Actual', 'Hora del Turno Actual', 'Fecha de Cierre','Fecha de Cambio', 'Hora de cambio','Tipo de Cambio','Error'];
          const header_r = ['RequestProposal_id','VendorPurchaseOrder_Num','OpPoint_id','TurningStorageArea_id','Supplier_id','Supplier_Description','CDay_id','CHour_id','Closing_Dt','NewCDay_id', 'NewCHour_id', 'Type_ind','RequestProposalStatus_Desc'];
          var resumenWS = XLSX.utils.json_to_sheet(this.mvm, {header: header_r}) 
          
    
          var range = XLSX.utils.decode_range(resumenWS['!ref']);
          for(var C = range.s.c; C <= range.e.c; ++C) {
            var colum = XLSX.utils.encode_col(C) + "1"; // <-- first row, column number C
            resumenWS[colum].v = header_r_f[C];
          }
    
          range.e['c'] = header_r_f.length - 1;
          resumenWS['!ref'] = XLSX.utils.encode_range(range);
    
    
          // A workbook is the name given to an Excel file
          var wb = XLSX.utils.book_new() // make Workbook of Excel
    
          // add Worksheet to Workbook
          // Workbook contains one or more worksheets
          XLSX.utils.book_append_sheet(wb, resumenWS, 'Resumen') // sheetAName is name of Worksheet
          //XLSX.utils.book_append_sheet(wb, detalleWS, 'Detalle')  
            
          var file='Lista_Cambios_a_aplicar.xlsx';
    
          // export Excel file
          XLSX.writeFile(wb, file) // name of the file is 'book.xlsx'
        },
        onexport1 () { 
                this.btn = true
                this.step_txt1="Aplicando cambios en OCs"
                this.step_txt2="Aplicando"
                this.dialog_new = true
                this.e1 = 1
                this.progressBar = true
                this.step_error1 = true
                this.step_error2 = true
                this.step_error3 = true
                this.step_color1 = "primary",
                this.step_color2 = "primary",
                this.step_color3 = "primary",
                this.msj_proceso = "Por favor aguarde un momento mientras se procesa la solicitud. ¡No cerrar esta ventana!"

                var data={Identification_Nbr:this.id_process, ApiUser_id:sessionStorage.getItem('ApiUser_id'), token:sessionStorage.getItem('access_token')}
     
                axios.post(this.api_tool_url + '/ApliChanges', data,{...this.config, timeout: 900000})
                .then(response => {
                        if(response.data.ResultRows == "OK") {
                            this.e1 = 1
                            this.step_color1 = "#008000"
                            this.progressBar = false
                            this.msj_proceso = 'Se realizaron los cambios correctamente.'
                            this.btn = false
                            this.active = false 
                            this.btnap= true
                            this.mvm=[] 
                        }
                        else {
                            this.e1 = 1
                            this.step_color1 = "#C0392B"
                            this.progressBar = false
                            this.msj_proceso = error.response.data.message
                            this.btn = false
                            this.active = true
                        }
                        this.btn = false
                    })
                    
                    .catch(error => {
                        this.btn = false;
                        this.step_error1 = false;
                        this.progressBar = false;
                        if (error.response && error.response.data && error.response.data.message) {
                            this.msj_proceso = error.response.data.message;
                        } else if (error.message) {
                            this.msj_proceso = `Error: ${error.message}`;
                        } else {
                            this.msj_proceso = "Ocurrio un error al procesar la solicitud.";
                        }
                        this.active = true;
                    })

                    
              },
        onexport2 () { 
          this.btn = true
          this.step_txt1="Aplicando cambios en OCs"
          this.step_txt2="Aplicando"
          this.dialog_new = true
          this.e1 = 1
          this.progressBar = true
          this.step_error1 = true
          this.step_error2 = true
          this.step_error3 = true
          this.step_color1 = "primary",
          this.step_color2 = "primary",
          this.step_color3 = "primary",
          this.msj_proceso = "Por favor aguarde un momento mientras se procesa la solicitud. ¡No cerrar esta ventana!"

          var data={Identification_Nbr:this.id_process, ApiUser_id:sessionStorage.getItem('ApiUser_id'), token:sessionStorage.getItem('access_token')}

          axios.post(this.api_tool_url + '/ApliChanges_TurningStorage', data, this.config)
          .then(response => {
                  if(response.data.ResultRows == "OK") {
                      this.e1 = 1
                      this.step_color1 = "#008000"
                      this.progressBar = false
                      this.msj_proceso = 'Se realizaron los cambios correctamente.'
                      this.btn = false
                      this.active = false 
                      this.btnap= true
                      this.mvm=[] 
                  }
                  else {
                      this.e1 = 1
                      this.step_color1 = "#C0392B"
                      this.progressBar = false
                      this.msj_proceso = error.response.data.message
                      this.btn = false
                      this.active = true
                  }
                  this.btn = false
              })
              
              .catch(error => {
                  this.btn = false;
                  this.step_error1 = false;
                  this.progressBar = false;
                  if (error.response && error.response.data && error.response.data.message) {
                      this.msj_proceso = error.response.data.message;
                  } else if (error.message) {
                      this.msj_proceso = `Error: ${error.message}`;
                  } else {
                      this.msj_proceso = "Ocurrio un error al procesar la solicitud.";
                  }
                  this.active = true;
              })

              
        },
        close() {
            this.dialog_new = false
        },
      }
    }
    </script>
    


// WEBPACK FOOTER //
// src/components/RequestProposalUpdate.vue